import { tg } from "./sdk";

/**
 * Contextual MainButton controller. Telegram exposes exactly one native
 * button — it has to be re-purposed per screen, not left static.
 *
 * PHASE 2 SCOPE DECISION: today's shell has no "selected tariff" state —
 * three tariff cards, each with its own inline buy button, no single
 * canonical action. Rather than invent new selection UX mid-hardening
 * pass (that's a Phase 3 redesign call), MainButton is wired to the one
 * unambiguous default: the "popular" tariff already visually emphasized
 * in the existing markup (`.tariff.popular`). It's shown only on the
 * Premium screen and hidden everywhere else. Revisit this mapping in
 * Phase 3 once screens have real primary-action semantics.
 */
let currentHandler: (() => void) | null = null;

export function showMainButton(text: string, onClick: () => void): void {
  const mb = tg?.MainButton;
  if (!mb) return;

  if (currentHandler) {
    mb.offClick(currentHandler);
  }
  currentHandler = onClick;

  mb.setText(text);
  mb.onClick(onClick);
  mb.show();
  mb.enable();
}

export function hideMainButton(): void {
  const mb = tg?.MainButton;
  if (!mb) return;
  if (currentHandler) {
    mb.offClick(currentHandler);
    currentHandler = null;
  }
  mb.hide();
}
